import { useNavigate } from "react-router-dom";
import { ProgramInfo } from "../../types/program.response";
import { Requirement } from "../../types/requirement.response";

export function useRequirementNav(
    programInfo: ProgramInfo,
    requirement: Requirement,
    onRequirementClick?: (programId: string, requirementId: string) => void
) {
    const navigate = useNavigate();
    return () => {
        if (onRequirementClick) {
            onRequirementClick(programInfo.id, requirement.info.id);
        } else {
            navigate(`/programs/${programInfo.id}/requirements/${requirement.info.id}`);
        }
    };
}
